module.exports = {
  path: 'validate_account',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/ValidateAccount'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/validateAccount/index.js